import { render, staticRenderFns } from "./Favorite.vue?vue&type=template&id=50bac3b8&scoped=true&"
import script from "./Favorite.vue?vue&type=script&lang=js&"
export * from "./Favorite.vue?vue&type=script&lang=js&"
import style0 from "./Favorite.vue?vue&type=style&index=0&id=50bac3b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bac3b8",
  null
  
)

export default component.exports